import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {FloorMap} from '../my-features/floor-map/floor-map.model';
@Injectable({
  providedIn: 'root'
})
export class FloorMapService {

  constructor(private http: HttpClient) { }

  ReadAllMap(params): Observable<any> {
    // return this.http.post<number>(`${environment.apiIotUrl}/map/read/all`, {otp: otp});
    return this.http.post<any>(`${environment.apiIotUrl}/map/read/all`, params);
  }

  ReadMapById(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/map/read/single`, params);
  }

  UpdateMap(params: FloorMap): Observable<any> {
    return this.http.post<FloorMap>(`${environment.apiIotUrl}/map/update`, params);
  }

  AddFloorMap(params: FloorMap): Observable<any> {
    return this.http.post<FloorMap>(`${environment.apiIotUrl}/map/add`, params);
  }

  DeleteFloorMap(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/map/delete`, params);
  }
}
